module.exports = __webpack_public_path__ + "img/header-red-square-top.7cd54194.svg";